<template>
  <div class="company-core-list">
    <status-bar @close="topStatus = null" v-if="topStatus" :text="topStatus.text" :state="topStatus.type"
                style="padding-top: 20px;"></status-bar>
    <div class="core-list-head"></div>
    <div class="core-list-body">
      <div class="core-list-body-h">
        <h3>我的应用</h3>
        <bcc-button v-if='[1,20,100].includes($store.state.arcUserInfo.level)' size='large' type="primary" :disabled="lockCompanyCore" @click="gotoCompanyCoreAdd">创建应用
        </bcc-button>
      </div>
      <div class="core-list-body-b">
        <div class="search-list">
          <div class="left">
            <bcc-select v-model="companyCoreType" width="120px" @on-change="changeCompanyCoreType">
              <bcc-option :value="option.value" v-for="(option, idx) in companyCoreTypeOptions" :key="idx"
                          :label="option.label"/>
            </bcc-select>
<!--            <bcc-search-input style="width: 180px;" placeholder="请搜索应用名称" class="search-name" @on-search="searchApplicationName"/>-->
          </div>
        </div>
        <bcc-table
          :columns="companyCoreColumn"
          :data="companyCoreData"
          emptyText="当前没有应用"
          :show-loading="companyCoreDataLoading"
          align="center">
          <template slot="app_plat" slot-scope="scope">
            <span v-html="renderAppType(scope.row.app_plat)"></span>
          </template>
          <template slot="state" slot-scope="scope">
            <span v-html="renderAppState(scope.row.state)"></span>
            <v-icon v-if='scope.row.state === 2' class="reject-help-img" @click="handleShowReason(scope)" name='help' />
          </template>
          <template slot="ctime" slot-scope="scope">
            <span>{{renderAppCtime(scope.row.ctime)}}</span>
          </template>
          <template slot="operate" slot-scope="scope">
            <router-link class="goto-company-core-scope"
                         :class="{'goto-company-core-scope-disabled': !scope.row.existOnline || lockCompanyCore}"
                         :disabled="!scope.row.existOnline || lockCompanyCore"
                         :to="{name: 'companyCoreScope', params: {client_id: scope.row.client_id}}"
                         @click.native="$LogReport.sendCustomEvent('openplat_appmanage_checkscope_click')"
            >查看接口详情
            </router-link>
            <router-link class="goto-company-core-scope"
                         :to="{name: 'companyCoreDetail', params: {client_id: scope.row.client_id}}"
                         @click.native="$LogReport.sendCustomEvent('openplat_appmanage_checkapp_click')"
            >查看应用详情
            </router-link>
            <span v-if='[1,20,100].includes($store.state.arcUserInfo.level)' class="delete-btn" :class="{'delete-disbale': scope.row.state === -1 }" @click="handleDelete(scope.row)">删除</span>
          </template>
        </bcc-table>

        <!-- <div class="core-list-pagination" v-if="companyCoreTotal > companyCorePs"> -->
        <!-- <div class="core-list-pagination">
          <p class="txt">每页显示</p>
          <bcc-select v-model="companyCorePs" width="80px" class="ps-select" @on-change="changePageSize">
            <bcc-option :value="option.value" v-for="(option, idx) in pageOptions" :key="idx"
                        :label="option.label"/>
          </bcc-select>
          <bcc-pagination
            :current="companyCorePn"
            :page-size="companyCorePs"
            :total="companyCoreTotal"
            @on-change="changeCompanyCorePage"
            show-elevator
            show-total
          ></bcc-pagination>
        </div> -->
      </div>
    </div>
    <reject-dialog ref="dialog" />
  </div>
</template>

<script>
import StatusBar from "../../components/StatusBar";
import RejectDialog from './rejectDialog'
import {login} from "@/utils/login"

export default {
  name: "companyCore",
  data() {
    return {
      companyCoreType: -100,
      pageOptions: [{
        label: 50,
        value: 50
      }, {
        label: 100,
        value: 100
      }, {
        label: 150,
        value: 150
      }, {
        label: 200,
        value: 200
      }],
      companyCoreTypeOptions: [
        {
          label: '全部应用',
          value: -100
        },
        {
          label: 'IOS应用',
          value: 0
        },
        {
          label: '安卓应用',
          value: 1
        },
        {
          label: '网页应用',
          value: 2
        },
      ],
      companyCoreTypeOptionsMap: [
        {
          label: '全部应用',
          value: -100
        },
        {
          label: 'IOS应用',
          value: 0
        },
        {
          label: '安卓应用',
          value: 1
        },
        {
          label: '网页应用',
          value: 2
        },
        {
          label: '小程序应用',
          value: 3
        }
      ],
      companyCoreColumn: [
        {
          title: '应用名称',
          key: 'app_name'
        },
        {
          title: '应用类型',
          key: 'app_plat'
        },
        {
          title: 'client_id',
          key: 'client_id',
          style: {
            width: '180px'
          }
        },
        {
          title: '状态',
          key: 'state'
        },
        {
          title: '创建时间',
          key: 'ctime',
        },
        {
          title: '操作',
          key: 'operate',
          style: {
            width: '300px'
          }
        }
      ],
      companyCoreData: [],
      companyCoreDataLoading: false,
      companyCorePn: 1,
      companyCorePs: 50,
      companyCoreTotal: 0,
      notify: null,
      topStatus: null
    }
  },
  created() {
    if (this.$store.state.userInfo) {
      this.$LogReport.sendCustomEvent('openplat_appmanage_page_load')
      this.renderCompanyCoreList().then(() => {
        this.renderTopBar()
      })
    } else {
      this.$router.push({
        name: 'home'
      })
      login()
    }
  },
  components: {
    StatusBar,
    RejectDialog
  },
  mounted() {
  },
  computed: {
    lockCompanyCore() {
      const companyInfo = this.$store.state.companyInfo
      return !(companyInfo && companyInfo.state === 1)
    }
  },
  beforeDestroy() {
    if (this.notify && this.notify.close) {
      this.notify.close()
    }
  },
  methods: {
    async handleDelete (row) {
      this.$confirm({
        mainText: '你确定要删除该应用吗？',
        showCancel: true,
        onOk: () => {
          this.$api.companyCore.delete({
            client_id: row.client_id
          }).then(() => {
            this.$message({
              content: '删除成功',
              type: 'success',
              offset: 60,
              duration: 1500
            })
            this.renderCompanyCoreList()
          }).catch((e) => {
            this.$message({
              content: e.message,
              type: 'exception',
              offset: 60,
              duration: 1500
            })
          })
        },
        onCancel: () => {
          console.log('cancel')
        }
      })
    },
    handleShowReason (scope) {
      this.$refs.dialog.reason = scope.row.remark
      this.$refs.dialog.show = true
    },
    changePageSize() {
      this.renderCompanyCoreList()
    },
    searchApplicationName(search) {
      console.log(search)
    },
    renderTopBar() {
      const {companyInfo, arcUserInfo} = this.$store.state
      if (!companyInfo) {
        this.topStatus = {
          text: '<span>您暂未填写身份认证信息，前往 <a href="/company/add">开放平台-信息填写</a> 完成身份信息填写并审核通过后，即可创建应用哦~</span>',
          type: 'info'
        }
      } else if (companyInfo.state === 1) {

        if (!this.companyCoreData.length) {
          if (![1, 20].includes(arcUserInfo.level)) {
            this.topStatus = {
              text: '<span>恭喜您！您的企业开发者资质已通过后台审核',
              type: 'success'
            }
          } else {
            this.topStatus = {
              text: '<span>恭喜您！您的企业开发者资质已通过后台审核，请开始 <a href="/company-core/add">创建应用</a> 吧！</span>',
              type: 'success'
            }
          }
        }
      } else if (companyInfo.state === 0) {
        this.topStatus = {
          text: '您的认证信息还在审核中，审核完成可接入应用',
          type: 'warning'
        }
      } else if (companyInfo.state === 2) {
        if (![1, 20].includes(arcUserInfo.level)) {
          this.topStatus = {
            text: '非常抱歉！您的企业开发者资质未通过后台审核，请联系管理员重新提交企业认证申请',
            type: 'error'
          }
        } else {
          this.topStatus = {
            text: '<span>非常抱歉！您的企业开发者资质未通过后台审核，请前往 <a href="/company/add">开放平台-信息填写</a> 重新提交企业认证申请吧~ </span>',
            type: 'error'
          }
        }
      }
    },
    async renderCompanyCoreList() {
      this.companyCoreDataLoading = true
      let app_plat = null
      if (typeof this.companyCoreType === 'number' && this.companyCoreType !== -100) app_plat = this.companyCoreType
      console.log('app_plat', app_plat)
      const params = {
        pn: this.companyCorePn,
        ps: this.companyCorePs,
        app_plat
      }
      await this.$api.companyCore.viewlist(params).then(data => {
        this.companyCoreData = data.list || []
        this.companyCorePn = data.page.pn
        this.companyCorePs = data.page.ps
        this.companyCoreTotal = data.page.total
        this.companyCoreDataLoading = false
      }).catch(e => {
        console.error(e)
        if (this.$store.state.companyInfo && this.$store.state.companyInfo === 1) {
          this.$message({
            content: e.message,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
        }
        this.companyCoreDataLoading = false
      })
    },
    changeCompanyCorePage(pn) {
      if (pn <= 0) return
      this.companyCorePn = pn
      this.renderCompanyCoreList()
    },
    renderAppType(type) {

      if (!Array.isArray(type)) return `<span style="color: #FA5A57;">未知应用(${type})</span>`

      const o =  type.map(item => {
        return this.companyCoreTypeOptionsMap.find(_type_ => _type_.value === item)
      })

      return o.map(item => item.label).join(',')
    },
    renderAppState(state) {
      switch (state) {
        case 0:
          return '<span style="color: #FAAB4B;">审核中</span>'
        case 1:
          return '<span>已开通</span>'
        case 2:
          return '<span style="color: #FA5A57;">已拒绝</span>'
        case -1:
          return '<span style="color: #FA5A57;">已注销</span>'
        default:
          return '<span style="color: #FA5A57;">未知状态(-1)</span>'
      }
    },
    renderAppCtime(ctime) {
      return window.moment.unix(ctime).format('YYYY-MM-DD HH:mm')
    },
    renderAppPlat(plat) {
      const arr = plat.map(i => {
        switch (i) {
          case 0:
            return 'iOS';
          case 1:
            return 'Android';
          case 2:
            return 'Web'
          case 3:
            return '小程序'
        }
      })
      return arr.join('，')
    },
    gotoCompanyCoreAdd() {
      if (this.companyCoreData.length >= 10) {
        this.$message({
          content: '最多只能创建10个应用',
          type: 'exception',
          offset: 60,
          duration: 1500
        })
      } else if (this.$store.state.companyInfo && this.$store.state.companyInfo.state === 1) {
        this.$LogReport.sendCustomEvent('openplat_newapp_click')
        this.$router.push({
          name: 'companyCoreAdd',
        })
      } else {
        this.$message({
          content: '企业认证未通过，无法添加应用',
          type: 'query',
          offset: 60,
          duration: 1500
        })
      }
    },
    changeCompanyCoreType() {
      // this.companyCorePs = 50
      this.companyCorePn = 1
      this.renderCompanyCoreList()
    }
  }
}
</script>

<style scoped lang="scss">
.company-core-list {
  min-width: 960px;
  width: 100%;
  max-width: 1168px;
  margin: auto;
  padding-bottom: 30px;
}

.core-list-head {
  padding: 16px 0 16px 26px;
}

.core-list-body {
  border: 1px solid #E7E7E7;
  min-height: 100px;

  .core-list-body-h {
    display: flex;
    align-items: center;
    padding: 0 26px;
    border-bottom: 1px solid #E7E7E7;
    height: 64px;
    justify-content: space-between;

    h3 {
      font-size: 24px;
      color: #212121;
    }
  }

  .core-list-body-b {
    padding: 24px;

    .core-list-pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;

      .txt {
        font-size: 14px;
        margin-right: 20px;
      }

      .ps-select {
        margin-right: 40px;
      }
    }

    .search-list {
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      .left {
        display: flex;
        flex: 1;
      }

      .search-name {
        margin-left: 20px;
        width: 400px;
      }
    }
  }
}

.reject-help-img {
  position: absolute;
  margin-left: 3px;
  margin-top: 2px;
  cursor: pointer;
}

.goto-company-core-scope {
  color: #1389BF;
}

.goto-company-core-scope + .goto-company-core-scope {
  margin-left: 18px;
}

.goto-company-core-scope-disabled {
  cursor: not-allowed !important;
  user-select: none;
  opacity: .5;
}
.delete-btn {
  display: inline-block;
  color: #1389BF;
  margin-left: 10px;
  cursor: pointer;
}
.delete-disbale {
  color: #1389BF;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
